/*@ngInject*/
module.exports = function printService() {

    this.printContent = function (title, content) {
        const popupWin = window.open('', '_blank');
        popupWin.document.open();
        popupWin.document.write('<html>' +
            '<head><title>Print - ' + title + '</title><style>' +
            'body{font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;} ' +
            'tr {border-bottom: #aaaaaa solid 1px} ' +
            'table {width: 100%; border-collapse: collapse;} ' +
            'h2,h3 {padding-top: 20px} ' +
            'h4 {padding-top: 10px;padding-bottom: 0px;} ' +
            'button {display: none} ' +
            'td,th {padding:5px; font-size: 11px ;font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;} ' +
            '.text-danger{color:red}</style></head>' +
            '<body onload="window.print()"><h2>'+ title + '</h2>' + content + '</body></html>');
        popupWin.document.close();
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/services/print.service.js
 **/